import { IProcessedOrders, OrderTypes } from "../constants";
import { SET_COLLECTION_POINTS, SET_FILTER_CRITERIA, SET_FILTER_STATE, SET_ORDERS, SET_TAB } from "./OrderParentActions";

export interface IOrderParentState {
    [key: string]: any;
    dineIn: IProcessedOrders[];
    delivery: IProcessedOrders[];
    collection: IProcessedOrders[];
    fullList: IProcessedOrders[];
    selectedTab: OrderTabs;
    filterState: any;
    filterCriteria: any;
    collectionPoints: any[];
}
export enum OrderTabs {
    ALL = "fullList",
    DINE_IN = "dineIn",
    DELIVERY = "delivery",
    COLLECTION = "collection"
}
const initalListState = {
    dineIn: [],
    delivery: [],
    collection: [],
    fullList: [],
}
export const initalState = {
    ...initalListState,
    selectedTab: OrderTabs.ALL,
    filterState: {},
    filterCriteria: {},
    collectionPoints: [],
}

export function OrderParentReducer(state: IOrderParentState, action: { type: string, payload: any }) {
    switch (action.type) {
        case SET_ORDERS:
            let newList = initalListState;
            if (Array.isArray(action.payload)) {
                newList = action.payload.reduce((prevItem: any, nextItem: IProcessedOrders) => {
                    if (nextItem.order_type) {
                        switch (nextItem.order_type) {
                            case OrderTypes.COLLECTION:
                                prevItem.collection.push(nextItem);
                                prevItem.fullList.push(nextItem);
                                break
                            case OrderTypes.PICKUP_NOW:
                                /**Stop displaying any that don't have a collection point assigned */
                                if (nextItem.collection_point_id !== null) {
                                    prevItem.collection.push(nextItem);
                                    prevItem.fullList.push(nextItem);
                                }
                                break
                            case OrderTypes.HOME_DELIVERY:
                                prevItem.delivery.push(nextItem);
                                prevItem.fullList.push(nextItem);
                                break
                            case OrderTypes.TABLE_DELIVERY:
                                prevItem.dineIn.push(nextItem);
                                prevItem.fullList.push(nextItem);
                                break
                        }
                    }
                    return prevItem;
                }, {
                    dineIn: [],
                    delivery: [],
                    collection: [],
                    fullList: []
                });
            }

            return {
                ...state,
                ...newList,
            }
        case SET_TAB:
            return {
                ...state,
                selectedTab: action.payload
            }
        case SET_FILTER_STATE:
            return {
                ...state,
                filterState: action.payload
            }
        case SET_FILTER_CRITERIA:
            const filterCriteria = {
                ...state.filterCriteria,
                [state.selectedTab]: action.payload
            }
            return {
                ...state,
                filterCriteria
            }
        case SET_COLLECTION_POINTS:
            return {
                ...state,
                collectionPoints: action.payload
            }
        default:
            return {
                ...state
            }
    }
}